import Services from '../../services'

class RAEApi {
  get(params) {
    return Services.get('/hrdu/approval_rae/list', { params })
  }

  getHistory(params) {
    return Services.get('/hrdu/approval_rae/history', { params })
  }

  getSingle(params) {
    return Services.get('/hrdu/approval_rae/detail', { params })
  }

  getSinglePeluang(params) {
    return Services.get('/hrdu/approval_rae/detail_peluang', { params })
  }

  getAnalisa(params) {
    return Services.get('/hrdu/approval_rae/analisa_barang_jadi_single/', { params })
  }

  save(data) {
    return Services.post('/hrdu/approval_rae/approve', data)
  }
}

export default new RAEApi()
